import {
  RoleLiteModel,
  RoleModel,
  getRolesKey,
  useGetRoles,
} from 'api-hooks/role';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { Input } from 'components/elements';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useMultiSelectInputHelper from 'hooks/use-multi-select-input-helper';
import useNavigation from 'hooks/use-navigation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

function transformer(item: RoleLiteModel | RoleModel): Option {
  return {
    id: item.id,
    label: item.name,
  };
}

interface Props {
  name: string;
  required?: boolean;
  label?: string;
  placeholder?: string;
  onClose?: () => void;
}

export default function RoleSelectMultiInput(props: Props) {
  const { control, setValue } = useFormContext<any>();
  const value = useWatch({ control, name: props.name });

  const { navigate } = useNavigation();

  const permission = useGetCrudPermission('roles');
  const { overrides, ...selectProps } = useMultiSelectInputHelper({
    value,
    onSelectItem: (value) => {
      setValue(props.name, value || [], {
        shouldTouch: true,
        shouldValidate: true,
      });
    },
    useListQueryHook: useGetRoles,
    listKeyFunction: getRolesKey,
    getMemoizedListVariables: React.useCallback(
      (page, q) => ({
        params: {
          q,
          page,
        },
      }),
      [],
    ),
    renderCreate: permission.create,
    onClickCreate: React.useCallback(() => {
      navigate(NavigationRoutes.RolesCreate);
      props.onClose?.();
    }, [navigate, props]),
    listTransformer: React.useCallback((result) => {
      return result.data.map((v) => transformer(v));
    }, []),
    paginationTransformer: React.useCallback((result) => {
      return result.meta;
    }, []),
  });

  return (
    <Input
      type="select"
      name={props.name}
      required={props.required}
      label={props.label}
      placeholder={props.placeholder}
      noMargin
      multi
      {...selectProps}
    />
  );
}
